<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p2tMz0/tc-custom/9780814795378.jpg?1719927337682" alt="This image is the cover for the book They Left Great Marks on Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">They Left Great Marks on Me
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A study of real accounts of the everyday violence experienced by emancipated African Americans in the late 19th and early 20th centuries.</b><br/><br/> Well after slavery was abolished, its legacy of violence left deep wounds on African Americans’ bodies, minds, and lives. For many victims and witnesses of the assaults, rapes, murders, nightrides, lynchings, and other bloody acts that followed, the suffering this violence engendered was at once too painful to put into words yet too horrible to suppress. Despite the trauma it could incur, many African Americans opted to publicize their experiences by testifying about the violence they endured and witness.<br/><br/> In this evocative and deeply moving study, Kidada E. Williams examines African Americans’ testimonies about racial violence. In the years between Emancipation and the Progressive Era, victims and witnesses verbally described acts of violence to friends, family, agents of the Freedmen’s Bureau and members of Congress. For those who could read and write, testimonies appeared in black newspapers, periodicals, and pamphlets. By using both oral and print culture to testify about violence, African Americans and their allies hoped they would be able to graphically disseminate enough knowledge about its occurrence that federal officials and the American people would be inspired to bear witness to their suffering and support their demands for justice. In the process of testifying, these people created a vernacular history of the violence they endured and witnessed. This history fostered an oppositional consciousness to racial violence that inspired African Americans to form and support campaigns to end violence. The resulting crusades against racial violence became one of the political training grounds for the civil rights movement. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kidada E Williams
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4bc7b102